module.exports = __webpack_public_path__ + "img/app-store-button.8dcaa92f.svg";